/**
 *
 * @param string dd/MM/yyyy
 * @returns yyyy-MM-dd
 */
export function reverseDate(date: string): string {
	const val = date.split('/')
	return `${val[2]}-${val[1]}-${val[0]}`
}
